import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { ListItemComponent, ListViewComponent } from 'components/layout/list-view/list-view.component';
import { AccountingPlanModel } from 'models/generated/Entities.Accounting.AccountingPlan';
import { ProductPlanModel } from 'models/generated/Entities.GormCrm.ProductPlan';
import { Layout } from 'modules/layout';
import { CurrencyPipe } from 'pipes/currency.pipe';
import { TranslatePipe } from 'pipes/translate.pipe';
import { AccountingService } from 'services/accounting.service';
import { NavigationService } from 'services/navigation.service';
import { ProductPlanService } from 'services/productplan.service';

@Component({
	selector: 'company-products-ledger-posts-save',
	templateUrl: './company-products-ledger-posts-save.component.html',
	imports: [Layout, ListViewComponent, ListItemComponent, CurrencyPipe, TranslatePipe]
})
export class CompanyProductsLedgerPostsSaveComponent implements OnDestroy {

	newTcv?: number;
	tcvDifference?: number;
	accountingPlan?: AccountingPlanModel;
	productPlan?: ProductPlanModel;

	annualContractValue?: number;
	isMismatchOfAcvAndAnnualRenewalValue: boolean = false;

	@Output()
	result = new EventEmitter<boolean>();

	constructor(
		private readonly navigation: NavigationService,
		private readonly accountingService: AccountingService,
		private readonly productPlanService: ProductPlanService)
	{ }

	checkMismatchOfAcvAndAnnualRenewalValue() {
		if (!this.accountingPlan || !this.productPlan || this.newTcv === undefined) throw new Error("Missing information: ProductPlan, AccountingPlan, NewTcv");
		this.annualContractValue = this.accountingService.generateAnnualContractValue(this.accountingPlan.startDate!, this.accountingPlan.endDate!, this.newTcv);
		this.tcvDifference = this.newTcv - this.accountingPlan.totalPlanValue;
		this.isMismatchOfAcvAndAnnualRenewalValue = (this.annualContractValue != undefined) && (Math.abs(this.annualContractValue - this.productPlan.annualValueForRenewal) >= 1);
	}

	updateAndSave() {
		if (!this.productPlan?.id || this.annualContractValue === undefined) return;
		this.productPlanService.setProductPlanAnnualValueForRenewal(this.productPlan.id, this.annualContractValue).then(() => {
			this.save();
		});		
	}

	save() {
		this.result.next(true);
		this.result.complete();
		this.navigation.closeView(this);
	}

	cancel() {
		this.result.next(false);
		this.result.complete();
		this.navigation.closeView(this);
	}

	ngOnDestroy(): void {
		this.cancel();
	}
}
